import Swiper from 'swiper'
import {Navigation} from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
    const sliderWrappers = document.querySelectorAll('.mtt-image-text-boxes-slider')

    if (sliderWrappers.length > 0) {
        sliderWrappers.forEach(sliderWrapper => {
            const swiperElement = sliderWrapper.querySelector('.mtt-image-text-boxes-slider__repeater-container')
            const nextButton = sliderWrapper.querySelector('.swiper-next')
            const prevButton = sliderWrapper.querySelector('.swiper-prev')

            const swiperOptions = {
                modules: [Navigation],
                spaceBetween: 24,
                slidesPerView: 1.1,
                loop: false,
                grabCursor: true,
                breakpoints: {
                    400: {
                        slidesPerView: 1.2
                    },
                    580: {
                        slidesPerView: 1.5
                    },
                    650: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 3
                    }
                }
            }

            if (nextButton && prevButton) {
                swiperOptions.navigation = {
                    nextEl: nextButton,
                    prevEl: prevButton
                }
            }

            const swiper = new Swiper(swiperElement, swiperOptions)

        })
    }
})